import produce from 'immer';
import { NFT_RENTAL_LOG_LIST_REQUEST } from '../../constants/log/nftRentalLogConstants';

const initialState = {

};

const nftRentalLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_RENTAL_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default nftRentalLogReducer;
